module.exports = __webpack_public_path__ + "static/media/hardwareUps.5ea03a11.png";